import { createSelector } from 'reselect';

import { getCheckout } from 'redux/modules/checkout/selectors/get-checkout';

export const getIsCheckoutLoaded = createSelector(
  getCheckout,
  state => state?.checkoutLoaded ?? false,
);
